import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Returning from Google OAuth — let AuthCallback exchange the session first.
    if (window.location.hash && window.location.hash.includes("session_id=")) { setReady(true); return; }
    const token = localStorage.getItem("nsa_token");
    if (!token) { setUser(false); setReady(true); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("nsa_token"); setUser(false); })
      .finally(() => setReady(true));
  }, []);

  const login = (token, u) => {
    localStorage.setItem("nsa_token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("nsa_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
